var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPfaApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16607_5785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8001 0V12.88C2.97431 13.2506 1.6001 14.8648 1.6001 16.8C1.6001 18.7352 2.97431 20.3494 4.8001 20.72V24H6.4001V20.72C8.22589 20.3494 9.6001 18.7352 9.6001 16.8C9.6001 14.8648 8.22589 13.2506 6.4001 12.88V0H4.8001Z",
    fill: "#636980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5999 0V3.28002C15.7741 3.65062 14.3999 5.26483 14.3999 7.2C14.3999 9.13517 15.7741 10.7494 17.5999 11.12V24H19.1999V11.12C21.0257 10.7494 22.3999 9.13517 22.3999 7.2C22.3999 5.26483 21.0257 3.65062 19.1999 3.28002V0H17.5999Z",
    fill: "#636980"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16607_5785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfaApproval);
export default __webpack_public_path__ + "static/media/pfa-approval.b6676ff3f6e3885871ed568e1964ce3f.svg";
export { ForwardRef as ReactComponent };